import { useContext, useEffect, useState } from "react";
import UserImg from "../../assets/img/user-account01.svg";
import Arrow from "../../assets/img/arrow-left-02.svg";
import Rightarrow from "../../assets/img/icome-arrow.svg";
import Backimg from "../../assets/img/skip-arrow.svg";
import Userimg from "../../assets/img/gridicons_user2.svg";
import Checkmark from "../../assets/img/checkmark-circle02.svg";
import useTranslator from "../../hooks/useTranslator";
import { haveValue } from "../../helper/common";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import Loader from "../../components/Loader";
import { trackClarityEvent } from "../../Utils/clarityReady";
import constants from "../../Utils/constants";
import Flag from "../../assets/img/flag.svg";

const GuarantorModal = ({
  user,
  formHandler,
  updateUserProfile,
  isGuarantor,
  usedFor,
  setBankshow,
  reconnectFlow = false,
  isDummySignup,
  setStep,
}) => {
  const { _t, i18n } = useTranslator();
  const navigate = useNavigate();
  const currentLang = (i18n.language || "en-us").toLowerCase();

  const { loadUserTenant } = useContext(AuthContext);
  const [doItLaterLoading, setDoItLaterLoading] = useState(false);
  const [redirectLoading, setRedirectLoading] = useState(false);

  const openPendingGuarantor = (guarantor) => {
    const params = new URLSearchParams({
      guarantorName: guarantor?.name || "",
    });
    const [firstName = "", ...lastNameParts] = (guarantor?.name || "")
      .trim()
      .split(/\s+/);
    params.set("firstName", firstName);
    if (lastNameParts.length) params.set("lastName", lastNameParts.join(" "));
    if (guarantor?.email) {
      params.set("email", guarantor.email);
    }
    const relation = guarantor?.gurantor_relation || guarantor?.relation;
    if (relation) params.set("gurantor_relation", relation);
    navigate(`/guarantor/onboarding?${params.toString()}`);
  };

  useEffect(() => {
    if (
      haveValue(user?.gurantor_added_id) &&
      user?.gurantor_added_id?.length > 0 &&
      !reconnectFlow
    ) {
      let total_added = user?.gurantor_added_id?.length;
      let total_flagged =
        (user?.tenant_extra_field_id?.selected_onboarding_users?.filter(
          (item) => item?.type == "guarantor"
        )?.length ?? 0) + +(user?.gurantor_added_id?.length ?? 0);
      if (total_added === total_flagged) {
        setRedirectLoading(true);
        trackClarityEvent("tenant_guarantor_added");
        handleSubmitLastStep();
      }
    }
  }, []);

  const handleDoItLater = async () => {
    if (doItLaterLoading) {
      return;
    }
    // In dummy mode, just navigate without any API call
    if (isDummySignup) {
      setStep(8);
      return;
    }
    const formData = {
      role: localStorage.getItem("usertype"),
      lang: localStorage.getItem("i18nextLng"),
      step: 8,
    };

    try {
      setDoItLaterLoading(true);
      trackClarityEvent("tenant_guarantor_step_skipped");
      setTimeout(() => {
        trackClarityEvent("tenant_context_step_started");
      }, constants.CLARITY_DELAY);
      await updateUserProfile(formData);
      await loadUserTenant("tenant");
    } catch (err) {
    } finally {
      setDoItLaterLoading(false);
    }
  };

  const handleSubmitLastStep = async () => {
    try {
      const formData = {
        role: "tenant",
        step: 8,
      };
      await updateUserProfile(formData);
      trackClarityEvent("tenant_guarantor_step_ended");
      setTimeout(() => {
        trackClarityEvent("tenant_context_step_started");
      }, constants.CLARITY_DELAY);
    } catch (err) {
      console.log("Error", err);
    } finally {
      setRedirectLoading(false);
    }
  };

  if (redirectLoading) return <Loader />;

  return (
    <>
      <div
        className={`approvedModal popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen ${
          isGuarantor ? "guarantorBg" : ""
        }`}
      >
        <div
          className="popup-content2 position-relative popup-content bg-white required-doc-popup guarantorModal"
          style={{ maxWidth: "800px" }}
          onClick={
            usedFor === "popup" || isGuarantor
              ? (e) => e.stopPropagation()
              : null
          }
        >
          <div
            className="cursor-pointer goBackButtonWrapper"
            style={{
              position: "absolute",
              top: 24,
              left: 24,
            }}
            onClick={() => {
              if (usedFor === "popup") {
                setBankshow(false);
              } else {
                formHandler?.prev?.();
              }
            }}
          >
            <img src="/images/arrow-right.svg" className="arrow-left" alt="" />
            <p>{_t("goBack")}</p>
          </div>
          <div className="guarantor-language-switcher">
            {currentLang.startsWith("es") ? (
              <div
                className="language-switch-container language-switch-container-es"
                onClick={() => i18n.changeLanguage("en-us")}
              >
                <p>ES</p>
                <img
                  className="flag-image"
                  alt="Spanish"
                  src="/images/spain-flag.png"
                />
              </div>
            ) : (
              <div
                className="language-switch-container"
                onClick={() => i18n.changeLanguage("es")}
              >
                <img className="flag-image" alt="English" src={Flag} />
                <p>EN</p>
              </div>
            )}
          </div>
          <div className="row relativeposition position-relative">
            <div className="col-12 d-flex gap-4 align-items-center justify-content-center heading-section">
              <div className="authenticateid-header authenticateidHeader text-center">
                <div className="customHeader">
                  <h4>
                    {usedFor === "popup"
                      ? _t(
                          "updateYourFinancialInformation",
                          "Text used at popup screen to connect bank"
                        )
                      : _t(
                          "youCanCompleteAddingYour",
                          "Text used in guarantor screen at onboarding flow"
                        )}
                  </h4>
                  <p>
                    {usedFor === "popup"
                      ? _t(
                          "completeAddingYourBankAccountForBetterExperience",
                          "Text used at popup screen to connect bank"
                        )
                      : _t(
                          "completeAddingYourGuarantorAndBankAccountForBetterExperience",
                          "Text used in guarantor screen at onboarding flow"
                        )}
                  </p>
                </div>
                {usedFor !== "popup" && (
                  <div
                    className="skipbtn cursor-pointer skipButtonMobile greenHover"
                    onClick={handleDoItLater}
                  >
                    <p>
                      {_t(
                        "skip",
                        "Text used in guarantor screen at onboarding flow"
                      )}
                    </p>
                    <img src={Backimg} alt="icon" className="canceicon" />
                  </div>
                )}
              </div>
            </div>
            {usedFor !== "popup" && (
              <div
                className="skipbtn cursor-pointer skipButtonDesktop greenHover"
                onClick={handleDoItLater}
              >
                <p>
                  {_t(
                    "iWillDoItLater",
                    "Text used in guarantor screen at onboarding flow"
                  )}
                </p>
                <img src={Backimg} alt="icon" className="canceicon" />
              </div>
            )}
          </div>
          <div className="dg_paddingdiv">
            <div className="row justify-content-center">
              {!isGuarantor && usedFor !== "popup" && (
                <div className="col-12 col-md-8 add_a_guarantor">
                  <div className="dgboxsetup bank-dgboxsetup h-100 position-relative">
                    {(!haveValue(
                      user?.tenant_extra_field_id?.selected_onboarding_users
                    ) ||
                      user?.tenant_extra_field_id?.selected_onboarding_users?.filter(
                        (item) => item?.type == "guarantor"
                      )?.length === 0) &&
                    (!haveValue(user?.gurantor_added_id) ||
                      user?.gurantor_added_id?.length === 0) ? (
                      <div className="wrapper-complete-screen1">
                        <img
                          className="userimagesetup"
                          src={UserImg}
                          alt="img"
                        />
                        <h6>
                          {_t(
                            "addAGuarantor",
                            "Text used in guarantor screen at onboarding flow"
                          )}
                        </h6>
                        <h5>
                          {_t(
                            "guarantorHelpsToMakeYourProfileStrongIfYouHaveALowIncome",
                            "Text used in guarantor screen at onboarding flow"
                          )}
                        </h5>
                        <p className="">
                          {_t(
                            "youCanSenaAGuarantorRequestOrCreateAnAccountOnTheirBehalf",
                            "Text used in guarantor screen at onboarding flow"
                          )}
                        </p>
                        <button
                          type="button"
                          className="btnNext btnnextpre continueButton w-100 uploadbtn nextButtonUploadFiles"
                          onClick={() => navigate("/guarantor/onboarding")}
                        >
                          {_t("addNow")}
                          <img
                            className="doc_Uploadimg"
                            src={Arrow}
                            alt="img"
                          />
                        </button>
                      </div>
                    ) : (
                      <div className="wrapper-complete-screen2">
                        <div className="d-flex align-items-center justify-content-between gap-2 completed-bar">
                          <div>
                            <img
                              className="userimagesetup"
                              src={UserImg}
                              alt="img"
                            />
                          </div>
                          <div>
                            <p>
                              {user?.gurantor_added_id?.length ?? 0}/
                              {(user?.tenant_extra_field_id?.selected_onboarding_users?.filter(
                                (item) => item?.type == "guarantor"
                              )?.length ?? 0) +
                                +(user?.gurantor_added_id?.length ?? 0)}{" "}
                              {_t("completed")}
                            </p>
                          </div>
                        </div>
                        <h6 className="add-guarantor-title">
                          {_t(
                            "addAGuarantor",
                            "Text used in guarantor screen at onboarding flow"
                          )}
                        </h6>
                        <h5 className="add-guarantor-subtitle">
                          {_t(
                            "theseGuarantorsComeFromTheDocumentsYouHadProvidedEarlierCompleteAdding",
                            "Text used in guarantor screen at onboarding flow"
                          )}
                        </h5>
                        <div
                          className={`guarantor-wrapper-setup ${
                            user?.tenant_extra_field_id?.selected_onboarding_users.filter(
                              (item) => item?.type == "guarantor"
                            )?.length +
                              user?.gurantor_added_id?.length ===
                            1
                              ? "guarantorWrapperSetup"
                              : ""
                          }`}
                        >
                          {Array.isArray(
                            user?.tenant_extra_field_id
                              ?.selected_onboarding_users
                          ) &&
                            user?.tenant_extra_field_id?.selected_onboarding_users
                              .filter((item) => item?.type == "guarantor")
                              .map((item, index) => {
                                return (
                                  <div
                                    key={index}
                                    className={`d-flex align-items-center justify-content-between gap-2 guarantor-multi-list addAGuarantorItem cursor-pointer`}
                                    onClick={() => openPendingGuarantor(item)}
                                  >
                                    <div className="d-flex align-items-center gap-2">
                                      <img
                                        src={Userimg}
                                        alt="User"
                                        className="userimg-space"
                                      />
                                      <div className="d-flex align-items-center userNameWrapper justify-content-between gap-2">
                                        <p className="m-0 userName">
                                          {item?.name}
                                        </p>
                                        {false && (
                                          <p className="m-0 status-text">
                                            {_t(
                                              "pendingForApproval",
                                              "Text used in guarantor screen at onboarding flow"
                                            )}
                                          </p>
                                        )}
                                      </div>
                                    </div>

                                    <img
                                      className="arrowimg"
                                      src={Rightarrow}
                                      alt="arrow"
                                    />
                                  </div>
                                );
                              })}

                          {Array.isArray(user?.gurantor_added_id) &&
                            user?.gurantor_added_id.map((item, index) => {
                              return (
                                <div
                                  key={index}
                                  className={`d-flex align-items-center justify-content-between gap-2 guarantor-multi-list cursor-pointer bg-added-state`}
                                >
                                  <div className="d-flex align-items-center gap-2">
                                    <img
                                      src={Userimg}
                                      alt="User"
                                      className="userimg-space"
                                    />
                                    <div className="d-flex align-items-center userNameWrapper justify-content-between gap-2">
                                      <p className="m-0 userName">
                                        {`${item?.guarantor_id?.fname ?? ""} ${
                                          item?.guarantor_id?.lname ?? ""
                                        }`}
                                      </p>

                                      <p className="m-0 status-text">
                                        {_t(
                                          "pendingForApproval",
                                          "Text used in guarantor screen at onboarding flow"
                                        )}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="added-approvle-div d-flex align-items-center justify-content-between gap-1">
                                    <spn>
                                      <img src={Checkmark} alt="check" />
                                    </spn>
                                    <span className="approval-addedbtn">
                                      {_t("added")}
                                    </span>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="d-flex guarantorButtonWrapper justify-content-center align-items-center onboarding-mobile-actions">
            {Array.isArray(user?.gurantor_added_id) &&
              user?.gurantor_added_id.length > 0 &&
              usedFor !== "popup" && (
                <button
                  onClick={(e) => {
                    if (usedFor === "popup") {
                      setBankshow(false);
                    }
                  }}
                  className="addGuarantorButton submitButton greenHover"
                >
                  {_t("submit")}
                </button>
              )}
          </div>
        </div>
      </div>
    </>
  );
};

export default GuarantorModal;
